import { render, staticRenderFns } from "./productlist_B.vue?vue&type=template&id=e361dbca&scoped=true&"
import script from "./productlist_B.vue?vue&type=script&lang=js&"
export * from "./productlist_B.vue?vue&type=script&lang=js&"
import style0 from "./productlist_B.vue?vue&type=style&index=0&id=e361dbca&lang=scss&scoped=true&"
import style1 from "./productlist_B.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e361dbca",
  null
  
)

export default component.exports